// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Shalani Chethana
 * @Date 10/10/2023
 */


 
.ContactForm_topic__VSxBt {
    font-size: 3rem;
    font-style: normal;
    font-weight: 600;
    margin-bottom: 3rem;
}

.ContactForm_outerContainer__dFQ\\+4 {
    /* background-color: #EFEFEF;
    border-radius: 1.5rem; */
    /* margin: 100px; */
    
}
.ContactForm_outerContainer__dFQ\\+4 form{
    max-width: 350px;
}

.ContactForm_formContainer__4Ff\\+D {
    /* background-color: #FFF; */
    border-radius: 1.5rem;
    /* margin: 3rem;
    margin-left: 3rem;
    padding: 3rem; */
    /* padding-bottom: 0; */
    width: 100%;
}

.ContactForm_formHeading__Rtg8T {
    color: #010e53ca;
    font-size: 3rem;
    font-style: normal;
    font-weight: 700;
}

.ContactForm_formInput__caQor {
    color: #3a3a3a !important;
    font-style: normal;
    font-weight: 500;
    margin-top: 20px;
}

.ContactForm_button__y89zq {
    margin: 2rem 0;
    padding: 10px 15px;
    font-size: 16px;
    border-radius: 5px;
    background-color: #5fa9e0;
    box-shadow: none;
}

.ContactForm_bottonIcon__YwJ6E {
    margin-right: 1rem;
    rotate: -45deg;
}


/* new  */
.ContactForm_contactDetailsTxt__9xSb- a{
    font-size: 14px;
    color: #000 !important;
}
.ContactForm_contactFormContentOuter__uQ--2{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background-color: #effffe;
    width: 100%;
}
.ContactForm_contactLocationOuters__7s5-f{
    display: flex;
    flex-direction: row;
    justify-content: left;
    width: 100%;
    padding: 100px;
}
.ContactForm_conatctFormMap__knDbA{
    width: 100%;
    height: 150px;
    margin-top: 10px;
    
}

.ContactForm_contactTopContentBox__4BOVe{
    text-align: left;
    margin: 100px;
}
.ContactForm_titelUnderLine__dfazw{
    height: 3px;
    width: 70px;
    border-radius: 3px;
    background-color:#077d92 ;
    margin: 20px 0px;
}
.ContactForm_titelFirsttxt__cZRlq{
    color:  #097ea8 ;
    letter-spacing: 2px;
    font-weight: 200;
}
.ContactForm_mainHeadertxt__uiRde{
    font-weight: 800;
    color: #1d1d1d;
}
.ContactForm_contentBodytxt__TeI8y{
    margin-top: 30px;
}
.ContactForm_contactAddressSect__UbaWX{
    width: 50%;
    padding-right: 30px;
    overflow-wrap: break-word;
}
.ContactForm_contactAddressMapSect__24dN1{
    width: 80%;
}
.ContactForm_contactDetailsLable__Ic2pe{
    margin-top: 20px;
    font-size: 20px;
    font-weight: 800;
}
.ContactForm_contactDetailsLableLitel__fLhbL{
    margin-top: 0px;
    font-size: 16px;
    font-weight: 700;
}
    

.ContactForm_videoCompOuterBox__cSyx-{
    width: 100%;
    height: 400px;
    overflow: hidden;
    position: relative;
    z-index: 0;
 }
.ContactForm_videoComp__D-Fzl{
    position: relative;
    width: 100vw;
    z-index: 1;
    /* height: 300px; */
}
.ContactForm_videoCompScuess__QQ8jk{
    position: relative;
    width: 100px;
    z-index: 1;
}
.ContactForm_videoBackgroundBox__VGZ9v{
    position: absolute;
    background-color: rgba(0, 0, 0, 0.508);
    color: #ffffff;
    z-index: 2;
    top: 200px;
    height: 100%;
    width: 100vw;
    padding: 50px 0px 50px 100px;
}
.ContactForm_videoBackgroundText__4LAn5{
    color: #ffffff;
    width: 50vw;
    
}


@media (max-width:1024px){
    .ContactForm_videoBackgroundText__4LAn5{
        width: 70vw;
        
    }
    .ContactForm_contactTopContentBox__4BOVe{
        margin: 100px 50px;
    }
    .ContactForm_contactFormContentOuter__uQ--2{
       align-items: center;
    }
    .ContactForm_contactFormImg__Umq6T{
        height: 400px;     
    }
    .ContactForm_formHeading__Rtg8T {
        font-size: 2rem;
        font-weight: 600;
    }
    .ContactForm_formContainer__4Ff\\+D {
        padding-left: 20px;
    }

}

@media (max-width:770px){
    .ContactForm_videoCompOuterBox__cSyx-{
        height: 200px;
        
     }
     .ContactForm_videoBackgroundText__4LAn5{
        font-size: x-small;
        font-weight: 200;
     }
     .ContactForm_videoBackgroundBox__VGZ9v{
        top: 50px;
        height: 100%;
        width: 100vw;
        padding: 20px 0px 20px 50px;
    }
    .ContactForm_contactFormContentOuter__uQ--2{
        flex-direction: column;
        align-items: center;
     }
     .ContactForm_contactFormImg__Umq6T{
         height: 400px;     
     }
     .ContactForm_contactLocationOuters__7s5-f{
        /* display: flex; */
        
        flex-direction: column;
        /* justify-content: space-between;
        width: 100%;
        margin-top: 100px; */
    }
    .ContactForm_contactAddressSect__UbaWX{
        width: 100%;
        
    }
    .ContactForm_contactAddressMapSect__24dN1{
        width: 100%;
    }
    .ContactForm_conatctFormMap__knDbA{
        width: 100%;
        height: 200px;
        margin: 10px 20px 50px 20px ;
        
    }
    
    
}
@media (max-width:480px){
    .ContactForm_videoBackgroundBox__VGZ9v{
        padding: 20px 0px 20px 20px;
    }
    .ContactForm_contactTopContentBox__4BOVe{
        margin: 50px 20px;
    }
    .ContactForm_contactAddressSect__UbaWX{
        margin: 0px 0px;
    }
    .ContactForm_contactLocationOuters__7s5-f{
        padding: 20px;
    }
    .ContactForm_conatctFormMap__knDbA{
        margin: 10px 0px 20px 0px ;
    }
    

}`, "",{"version":3,"sources":["webpack://./src/components/contact/ContactForm.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;;;AAIF;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI;4BACwB;IACxB,mBAAmB;;AAEvB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,qBAAqB;IACrB;;oBAEgB;IAChB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;;AAGA,SAAS;AACT;IACI,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;IACX,cAAc;AAClB;AACA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;;AAEpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;;AAGA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;CACb;AACD;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,sCAAsC;IACtC,cAAc;IACd,UAAU;IACV,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,4BAA4B;AAChC;AACA;IACI,cAAc;IACd,WAAW;;AAEf;;;AAGA;IACI;QACI,WAAW;;IAEf;IACA;QACI,kBAAkB;IACtB;IACA;OACG,mBAAmB;IACtB;IACA;QACI,aAAa;IACjB;IACA;QACI,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,kBAAkB;IACtB;;AAEJ;;AAEA;IACI;QACI,aAAa;;KAEhB;KACA;QACG,kBAAkB;QAClB,gBAAgB;KACnB;KACA;QACG,SAAS;QACT,YAAY;QACZ,YAAY;QACZ,2BAA2B;IAC/B;IACA;QACI,sBAAsB;QACtB,mBAAmB;KACtB;KACA;SACI,aAAa;KACjB;KACA;QACG,mBAAmB;;QAEnB,sBAAsB;QACtB;;4BAEoB;IACxB;IACA;QACI,WAAW;;IAEf;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;QACX,aAAa;QACb,4BAA4B;;IAEhC;;;AAGJ;AACA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;IACA;QACI,aAAa;IACjB;IACA;QACI,0BAA0B;IAC9B;;;AAGJ","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Shalani Chethana\r\n * @Date 10/10/2023\r\n */\r\n\r\n\r\n \r\n.topic {\r\n    font-size: 3rem;\r\n    font-style: normal;\r\n    font-weight: 600;\r\n    margin-bottom: 3rem;\r\n}\r\n\r\n.outerContainer {\r\n    /* background-color: #EFEFEF;\r\n    border-radius: 1.5rem; */\r\n    /* margin: 100px; */\r\n    \r\n}\r\n.outerContainer form{\r\n    max-width: 350px;\r\n}\r\n\r\n.formContainer {\r\n    /* background-color: #FFF; */\r\n    border-radius: 1.5rem;\r\n    /* margin: 3rem;\r\n    margin-left: 3rem;\r\n    padding: 3rem; */\r\n    /* padding-bottom: 0; */\r\n    width: 100%;\r\n}\r\n\r\n.formHeading {\r\n    color: #010e53ca;\r\n    font-size: 3rem;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n}\r\n\r\n.formInput {\r\n    color: #3a3a3a !important;\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    margin-top: 20px;\r\n}\r\n\r\n.button {\r\n    margin: 2rem 0;\r\n    padding: 10px 15px;\r\n    font-size: 16px;\r\n    border-radius: 5px;\r\n    background-color: #5fa9e0;\r\n    box-shadow: none;\r\n}\r\n\r\n.bottonIcon {\r\n    margin-right: 1rem;\r\n    rotate: -45deg;\r\n}\r\n\r\n\r\n/* new  */\r\n.contactDetailsTxt a{\r\n    font-size: 14px;\r\n    color: #000 !important;\r\n}\r\n.contactFormContentOuter{\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    background-color: #effffe;\r\n    width: 100%;\r\n}\r\n.contactLocationOuters{\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: left;\r\n    width: 100%;\r\n    padding: 100px;\r\n}\r\n.conatctFormMap{\r\n    width: 100%;\r\n    height: 150px;\r\n    margin-top: 10px;\r\n    \r\n}\r\n\r\n.contactTopContentBox{\r\n    text-align: left;\r\n    margin: 100px;\r\n}\r\n.titelUnderLine{\r\n    height: 3px;\r\n    width: 70px;\r\n    border-radius: 3px;\r\n    background-color:#077d92 ;\r\n    margin: 20px 0px;\r\n}\r\n.titelFirsttxt{\r\n    color:  #097ea8 ;\r\n    letter-spacing: 2px;\r\n    font-weight: 200;\r\n}\r\n.mainHeadertxt{\r\n    font-weight: 800;\r\n    color: #1d1d1d;\r\n}\r\n.contentBodytxt{\r\n    margin-top: 30px;\r\n}\r\n.contactAddressSect{\r\n    width: 50%;\r\n    padding-right: 30px;\r\n    overflow-wrap: break-word;\r\n}\r\n.contactAddressMapSect{\r\n    width: 80%;\r\n}\r\n.contactDetailsLable{\r\n    margin-top: 20px;\r\n    font-size: 20px;\r\n    font-weight: 800;\r\n}\r\n.contactDetailsLableLitel{\r\n    margin-top: 0px;\r\n    font-size: 16px;\r\n    font-weight: 700;\r\n}\r\n    \r\n\r\n.videoCompOuterBox{\r\n    width: 100%;\r\n    height: 400px;\r\n    overflow: hidden;\r\n    position: relative;\r\n    z-index: 0;\r\n }\r\n.videoComp{\r\n    position: relative;\r\n    width: 100vw;\r\n    z-index: 1;\r\n    /* height: 300px; */\r\n}\r\n.videoCompScuess{\r\n    position: relative;\r\n    width: 100px;\r\n    z-index: 1;\r\n}\r\n.videoBackgroundBox{\r\n    position: absolute;\r\n    background-color: rgba(0, 0, 0, 0.508);\r\n    color: #ffffff;\r\n    z-index: 2;\r\n    top: 200px;\r\n    height: 100%;\r\n    width: 100vw;\r\n    padding: 50px 0px 50px 100px;\r\n}\r\n.videoBackgroundText{\r\n    color: #ffffff;\r\n    width: 50vw;\r\n    \r\n}\r\n\r\n\r\n@media (max-width:1024px){\r\n    .videoBackgroundText{\r\n        width: 70vw;\r\n        \r\n    }\r\n    .contactTopContentBox{\r\n        margin: 100px 50px;\r\n    }\r\n    .contactFormContentOuter{\r\n       align-items: center;\r\n    }\r\n    .contactFormImg{\r\n        height: 400px;     \r\n    }\r\n    .formHeading {\r\n        font-size: 2rem;\r\n        font-weight: 600;\r\n    }\r\n    .formContainer {\r\n        padding-left: 20px;\r\n    }\r\n\r\n}\r\n\r\n@media (max-width:770px){\r\n    .videoCompOuterBox{\r\n        height: 200px;\r\n        \r\n     }\r\n     .videoBackgroundText{\r\n        font-size: x-small;\r\n        font-weight: 200;\r\n     }\r\n     .videoBackgroundBox{\r\n        top: 50px;\r\n        height: 100%;\r\n        width: 100vw;\r\n        padding: 20px 0px 20px 50px;\r\n    }\r\n    .contactFormContentOuter{\r\n        flex-direction: column;\r\n        align-items: center;\r\n     }\r\n     .contactFormImg{\r\n         height: 400px;     \r\n     }\r\n     .contactLocationOuters{\r\n        /* display: flex; */\r\n        \r\n        flex-direction: column;\r\n        /* justify-content: space-between;\r\n        width: 100%;\r\n        margin-top: 100px; */\r\n    }\r\n    .contactAddressSect{\r\n        width: 100%;\r\n        \r\n    }\r\n    .contactAddressMapSect{\r\n        width: 100%;\r\n    }\r\n    .conatctFormMap{\r\n        width: 100%;\r\n        height: 200px;\r\n        margin: 10px 20px 50px 20px ;\r\n        \r\n    }\r\n    \r\n    \r\n}\r\n@media (max-width:480px){\r\n    .videoBackgroundBox{\r\n        padding: 20px 0px 20px 20px;\r\n    }\r\n    .contactTopContentBox{\r\n        margin: 50px 20px;\r\n    }\r\n    .contactAddressSect{\r\n        margin: 0px 0px;\r\n    }\r\n    .contactLocationOuters{\r\n        padding: 20px;\r\n    }\r\n    .conatctFormMap{\r\n        margin: 10px 0px 20px 0px ;\r\n    }\r\n    \r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"topic": `ContactForm_topic__VSxBt`,
	"outerContainer": `ContactForm_outerContainer__dFQ+4`,
	"formContainer": `ContactForm_formContainer__4Ff+D`,
	"formHeading": `ContactForm_formHeading__Rtg8T`,
	"formInput": `ContactForm_formInput__caQor`,
	"button": `ContactForm_button__y89zq`,
	"bottonIcon": `ContactForm_bottonIcon__YwJ6E`,
	"contactDetailsTxt": `ContactForm_contactDetailsTxt__9xSb-`,
	"contactFormContentOuter": `ContactForm_contactFormContentOuter__uQ--2`,
	"contactLocationOuters": `ContactForm_contactLocationOuters__7s5-f`,
	"conatctFormMap": `ContactForm_conatctFormMap__knDbA`,
	"contactTopContentBox": `ContactForm_contactTopContentBox__4BOVe`,
	"titelUnderLine": `ContactForm_titelUnderLine__dfazw`,
	"titelFirsttxt": `ContactForm_titelFirsttxt__cZRlq`,
	"mainHeadertxt": `ContactForm_mainHeadertxt__uiRde`,
	"contentBodytxt": `ContactForm_contentBodytxt__TeI8y`,
	"contactAddressSect": `ContactForm_contactAddressSect__UbaWX`,
	"contactAddressMapSect": `ContactForm_contactAddressMapSect__24dN1`,
	"contactDetailsLable": `ContactForm_contactDetailsLable__Ic2pe`,
	"contactDetailsLableLitel": `ContactForm_contactDetailsLableLitel__fLhbL`,
	"videoCompOuterBox": `ContactForm_videoCompOuterBox__cSyx-`,
	"videoComp": `ContactForm_videoComp__D-Fzl`,
	"videoCompScuess": `ContactForm_videoCompScuess__QQ8jk`,
	"videoBackgroundBox": `ContactForm_videoBackgroundBox__VGZ9v`,
	"videoBackgroundText": `ContactForm_videoBackgroundText__4LAn5`,
	"contactFormImg": `ContactForm_contactFormImg__Umq6T`
};
export default ___CSS_LOADER_EXPORT___;
